import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Path-style dashboard deep link — ``/workspace/dashboard/<id>``.
 *
 * The backend share flow (in-app notification + email CTA, see
 * ``DASHBOARD_DEEP_LINK_PATH`` in ``dashboard_share_service.py``) emits this
 * path form, but the dashboard surface selects its target through the
 * ``?dashboard=<id>`` search param. Without this route the link rendered
 * "Not Found". We redirect on ``beforeLoad`` so links already sent by email
 * keep working; no React render of this file happens.
 */
export const Route = createFileRoute("/_authed/workspace/dashboard_/$dashboardId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/workspace/dashboard",
      search: { dashboard: params.dashboardId },
    });
  },
});
